import { trackEvent } from 'tracking/tracking';
import { TrackingPlaceInApp } from '@ardoq/data-model';

const { RIGHT_PANE_TOOLBAR } = TrackingPlaceInApp;

export const trackButtonClicked = (
  action: string,
  isViewpointMode: boolean
) => {
  trackEvent(`${RIGHT_PANE_TOOLBAR} clicked ${action}`, {
    isViewpointMode,
  });
};

export const trackTabClicked = (tab: string, isViewpointMode: boolean) => {
  trackEvent(`${RIGHT_PANE_TOOLBAR} clicked ${tab}`, {
    isViewpointMode,
  });
};
